export const UI_SOURCES = {
  booking: "Booking",
  imprt: "Import",
  mls: "MLS",
  highrise: "HighRise",
}

export const TYPE_FILTER_OPTIONS = [
  { id: "booking", label: "Booking" },
  { id: "is_concierge_booking", label: "Concierge Booking" },
  { id: "imprt", label: "Import" },
  { id: "marketing", label: "Marketing" },
  { id: "mls", label: "MLS" },
  { id: "is_radar", label: "HighRise" },
]

export function getCandidateTypeLabel(candidate) {
  if (candidate.is_concierge_booking) {
    return "Concierge Booking"
  }
  if (candidate.is_radar) {
    return "HighRise"
  }
  if (candidate.type === "marketing") {
    return "Marketing"
  }
  return UI_SOURCES[candidate.ui_source]
}
